import { Session } from '@ais-ui/auth';
import { Bookmark } from './bookmarks/types';

export type BoundingBox = {
  crs: string;
  extent: number[];
};

export type WMSLayerInfo = {
  id: string;
  title: string;
  name: string;
  coordinateSystems: string[];
  boundingBox: BoundingBox[];
  enabled: boolean;
  isBase?: boolean;
};

export type WMSInfo = {
  id: string;
  enabled: boolean;
  exception: string;
  name: string;
  patch: null | string;
  refreshrate: number;
  selected: string[];
  singletile?: boolean;
  singleTile?: boolean;
  baseMap?: boolean;
  trans?: number;
  transparency?: number;
  url: string;
  version: string;
  layers?: WMSLayerInfo[];
};

export type VectorTile = {
  id: string;
  enabled: boolean;
  name: string;
  url: string;
};

export interface Settings {
  'assetDisplay.mapengine': {
    enableUserSpecificS57: boolean;
    fEnableOSM: boolean;
    fEnableS57: boolean;
    osmBaseName: string;
    osmBaseUrl: string;
    osmHeaders: any[];
    viewParam: {
      center: {
        lat: number;
        lon: number;
      };
      zoomLevel: number;
    };
  };
  'ribbonPlugin.settings': Record<string, any>;
  wmsSettings: WMSInfo[];
  vectorTiles: VectorTile[];
  homeBookmark?: Bookmark;
}

export const getSettings = async (session: Session): Promise<Settings> => {
  const response = await session.request('get', {
    defaultSettings: false,
    serverUid: 'd4bd4710-1765-4476-8969-09ab9d0b676f',
  });

  return JSON.parse(response);
};

export const getDefaultSettings = async (
  session: Session
): Promise<Settings> => {
  const response = await session.request('get', {
    defaultSettings: true,
    serverUid: 'd4bd4710-1765-4476-8969-09ab9d0b676f',
  });

  return JSON.parse(response);
};

export const setSettings = async (
  session: Session,
  settings: Settings
): Promise<null> => {
  const response = await session.request('set', {
    configuration: JSON.stringify(settings),
  });

  return response;
};
